{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversații selectate",
    "AGENT_SELECT_LABEL": "Selectați agentul",
    "ASSIGN_CONFIRMATION_LABEL": "Sigur doriți să atribuiți {conversationCount} {conversationLabel} la",
    "UNASSIGN_CONFIRMATION_LABEL": "Sigur doriți să anulați atribuirea a {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Mergeți înapoi",
    "ASSIGN_LABEL": "Atribuiți",
    "YES": "Da",
    "SEARCH_INPUT_PLACEHOLDER": "Caută",
    "ASSIGN_AGENT_TOOLTIP": "Atribuiți agent",
    "ASSIGN_TEAM_TOOLTIP": "Atribuiți echipă",
    "ASSIGN_SUCCESFUL": "Conversațiile au fost atribuite.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversațiile au fost rezolvate.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversațiile vizibile pe această pagină sunt doar selectate.",
    "AGENT_LIST_LOADING": "Se încarcă agenții",
    "UPDATE": {
      "CHANGE_STATUS": "Schimbați statusul",
      "SNOOZE_UNTIL": "Amânați",
      "UPDATE_SUCCESFUL": "Statusul conversației a fost actualizat.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "Nu s-au găsit etichete pentru",
      "ASSIGN_SELECTED_LABELS": "Atribuiți etichetele selectate",
      "ASSIGN_SUCCESFUL": "Etichete atribuite cu succes.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Selectați echipa",
      "NONE": "Nimic",
      "NO_TEAMS_AVAILABLE": "Nu există încă echipe adăugate la acest cont.",
      "ASSIGN_SELECTED_TEAMS": "Atribuirea echipei selectate.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Îmbină conversații",
      "TITLE": "Îmbină conversații",
      "DESCRIPTION": "Selectați o conversație țintă. Toate celelalte conversații selectate vor fi îmbinate în ea — mesajele lor vor fi mutate în conversația țintă, iar conversațiile sursă vor fi șterse.",
      "TARGET_LABEL": "Conversație țintă (va fi păstrată)",
      "SOURCES_LABEL": "Conversații sursă (vor fi șterse)",
      "SELECT_TARGET": "Selectați o conversație ca țintă pentru îmbinare",
      "WARNING": "Avertisment: Această acțiune nu poate fi anulată. Mesajele din toate conversațiile sursă vor fi mutate în conversația țintă, iar conversațiile sursă vor fi șterse definitiv.",
      "SUBMIT": "Îmbină conversații",
      "CANCEL": "Anulează",
      "SUCCESS_MESSAGE": "Conversații îmbinate cu succes",
      "ERROR_MESSAGE": "Nu s-au putut îmbina conversațiile. Vă rugăm să încercați din nou.",
      "CONFIRM": {
        "TITLE": "Confirmă îmbinarea",
        "DESCRIPTION": "Sigur doriți să îmbinați {sourceCount} conversații în #{targetId}? Această acțiune nu poate fi anulată.",
        "YES": "Da, îmbină",
        "CANCEL": "Anulează"
      }
    }
  }
}
